import { roundWaitTime } from '@spcc/core'
import type { WaitTimeKind } from '@spcc/core'

/** Sales-order screen wording for a live wait estimate (rounding lives in core). */
export const WAIT_TIME_KEYS: Record<WaitTimeKind, string> = {
  none: 'salesOrders.waitNone',
  minutes: 'salesOrders.waitMinutes',
  hours: 'salesOrders.waitHours',
  hoursMinutes: 'salesOrders.waitHoursMinutes',
}

export interface WaitTimeLabel {
  key: string
  params: { minutes?: number; hours?: number }
}

/** null when there is no estimate — the screen then shows nothing. */
export function formatWaitTime(minutes: number | null | undefined): WaitTimeLabel | null {
  const rounded = roundWaitTime(minutes)
  return rounded && { key: WAIT_TIME_KEYS[rounded.kind], params: rounded.params }
}
